<template>
  <div>
    <div v-if="puzzleHistory.attributes.rating != null">
      Your Review
      <div class="d-flex align-center"><v-rating
          color="blue"
          background-color="gray"
          half-increments
          length="5"
          value="0"
          dense
          size="24"
          readonly
          :value="parseFloat(puzzleHistory.attributes.rating)"
      ></v-rating>
      </div>
    </div>
    <div>
      <v-dialog
          v-model="dialog"
          width="100%"
          max-width="400" v-if="puzzleHistory.attributes.rating == null">
        <template v-slot:activator="{ on, attrs }" >
          <v-btn small color="orange"  v-bind="attrs"
                 v-on="on" @click.stop.prevent>Write Your Review</v-btn>
        </template>

        <v-card>
          <v-col cols="6" style="margin: 0 auto" class="pt-5 pb-5" v-if="submitted">
            <v-progress-linear
                color="blue accent-4"
                indeterminate
                rounded
                height="6"
            ></v-progress-linear>
          </v-col>
          <v-container class="align-center" v-if="!submitted">

            <h3 class="text-center">Rate the following features of the puzzle on a 1-5 star scale</h3>

            <div class="d-flex align-center mb-4 mt-4"><div>Did you like the image:<br/><small>Is it engaging?</small></div>
              <v-rating
                  color="red accent-3"
                  background-color="gray"
                  length="5"
                  value="0"
                  dense
                  x-large
                  :value="localPuzzleHistory.imageQuality"
                  v-model="localPuzzleHistory.imageQuality"
              ></v-rating>
            </div>
            <div class="d-flex align-center mb-4">
              <div>Difficulty:<br/><small>Did you struggle to solve it?</small></div>
              <v-rating
                  color="green accent-3"
                  background-color="gray"
                  length="5"
                  value="0"
                  dense
                  x-large
                  :value="localPuzzleHistory.difficulty"
                  v-model="localPuzzleHistory.difficulty"
              ></v-rating>
            </div>
            <div class="d-flex align-center mb-4">
              <div>Piece Fit:<br/><small>Was the snap satisfying?</small></div>
              <v-rating
                  color="amber accent-2"
                  background-color="gray"
                  length="5"
                  value="0"
                  dense
                  x-large
                  :value="localPuzzleHistory.pieceFit"
                  v-model="localPuzzleHistory.pieceFit"
              ></v-rating>
            </div>
            <p>
              Provide an optional written review:
            </p>
            <v-textarea filled v-model="localPuzzleHistory.reviewText"
                        class="mb-0"
                        rows="3">

            </v-textarea>
            <div class="d-flex">
              <v-btn
                  color="success"
                  @click="submit"
                  :disabled="!localPuzzleHistory.pieceFit || !localPuzzleHistory.difficulty || !localPuzzleHistory.imageQuality"
              >
                Save
              </v-btn>
              <v-spacer class="d-none d-flex"></v-spacer>
              <v-btn
                  color="warning"
                  @click="dialog = false"
              >
                Cancel
              </v-btn>
            </div>
            <div class="text-center"><small>You cannot edit this once submitted</small></div>
          </v-container>
        </v-card>
      </v-dialog>


    </div>
    <small v-if="puzzleHistory.attributes.rating != null">
      <div class="d-flex">Puzzle Image Quality ({{puzzleHistory.attributes.imageQuality}}):
        <v-rating
            color="red"
            background-color="gray"
            half-increments
            length="5"
            value="0"
            dense
            size="14"
            readonly
            :value="puzzleHistory.attributes.imageQuality"
            v-model="puzzleHistory.attributes.imageQuality"
        ></v-rating>
      </div>
      <div class="d-flex">
        Difficulty ({{puzzleHistory.attributes.difficulty}}):
        <v-rating
            color="light-green darken-2"
            background-color="gray"
            half-increments
            length="5"
            value="0"
            dense
            size="14"
            readonly
            :value="puzzleHistory.attributes.difficulty"
            v-model="puzzleHistory.attributes.difficulty"
        ></v-rating>
      </div>
      <div class="d-flex">
        Piece fit ({{puzzleHistory.attributes.pieceFit}}):
        <v-rating
            color="yellow darken-2"
            background-color="gray"
            half-increments
            length="5"
            value="0"
            dense
            size="14"
            readonly
            :value="puzzleHistory.attributes.pieceFit"
            v-model="puzzleHistory.attributes.pieceFit"
        ></v-rating>
      </div>
    </small>
    <div>
      {{puzzleHistory.attributes.reviewText}}
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {mapGetters} from "vuex";

export default {
  name: 'ratings_display',
  components: {
  },
  computed: {
    ...mapGetters({
      puzzleHistories: 'getPuzzleHistories',
      modified: 'getModfiedPuzzleHistory'
    }),
    ...mapState({
    }),
  },
  created: function(){
  },
  mounted: function(){
    this.copyLocal()
  },
  methods: {
    submit: function(){
      this.$store.dispatch("updatePuzzleReview", this.localPuzzleHistory)
      this.submitted = true
    },
    copyLocal: function(){
      if (this.puzzleOrderId != 0 && this.puzzleOrderId != null) {
        for (let index in Object.keys(this.puzzleHistories)) {
          let key = Object.keys(this.puzzleHistories)[index];
          if (this.puzzleHistories[key].attributes.puzzleOrderId == this.puzzleOrderId){
            this.puzzleHistory = this.puzzleHistories[key];
            Object.keys(this.puzzleHistory.attributes).forEach(key => {
              this.localPuzzleHistory[key] = this.puzzleHistory[key]
            });
            this.localPuzzleHistory['id'] = this.puzzleHistory.id
          }
        }
      }
    }
  },
  watch: {
    modified: {
      handler(n,o) {
        if (!n && o){
          this.dialog = false
          this.copyLocal()
        }
      },
      deep: true
    }
  },
  data: function(){
    return {
      puzzleHistory: {
        attributes: {
          rating: 0
        }
      },
      localPuzzleHistory: {
        rating: 0,
        imageQuality: 0,
        pieceFit: 0,
        difficulty: 0,
      },
      dialog: false,
      submitted: false
    }
  },
  props: {
    puzzleOrderId: 0
  }
}
</script>
<style scoped>


</style>